import React from 'react';
import classes from './BorderedCheckbox.module.scss';
import { BorderedCheckboxProps } from './BorderedCheckbox.types';
import Checkbox from '../Checkbox/Checkbox';
import HelpText from '..//HelpText/HelpText';

/**
 * Pass in the "name" prop to group checkboxs together. Then each checkbox needs a unique "value" prop. This wrapper component
 * controls the selected state of the checkbox button, so use `selected` and `onSelect` to manage that state from the parent component.
  - use the `extraProps` object to pass props to the label or input elements such as onChange, onBlur, etc.
  - The primary component has:
    - CSS modules
    - Tailwind styles
    - CSS variables
  - To make sure all different CSS channels are working
  */
const BorderedCheckbox: React.FC<BorderedCheckboxProps> = ({
  size = 'default',
  selected,
  onSelect = () => {},
  className = '',
  disabled,
  helpText,
  children,
  extraProps = {},
  ...props
}) => {
  const checkboxProps = {
    ...props,
    selected,
    disabled,
    onChange: onSelect,
    extraProps: {
      input: {
        ...(extraProps.input || {}),
        checked: selected,
      },
    },
  };

  const helpTextProps = {
    ...(props.extraProps?.helpText || {}), // Allow overriding default helpText props
  };

  return (
    <>
      <div
        className={[
          classes['bordered-checkbox'],
          classes[`size-${size}`],
          selected ? classes['selected'] : '',
          disabled ? classes['disabled'] : '',
          className,
        ].join(' ')}
        onClick={(e) => onSelect()}
      >
        <Checkbox {...checkboxProps} />
        {children}
      </div>
      {helpText && <HelpText {...helpTextProps}>{helpText}</HelpText>}
    </>
  );
};

export default BorderedCheckbox;
